/* tslint:disable */

declare var Object: any;
export interface TaskFeedbackServiceInterface {
  "id"?: number;
}

export class TaskFeedbackService implements TaskFeedbackServiceInterface {
  "id": number;
  constructor(data?: TaskFeedbackServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TaskFeedbackService`.
   */
  public static getModelName() {
    return "TaskFeedbackService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TaskFeedbackService for dynamic purposes.
  **/
  public static factory(data: TaskFeedbackServiceInterface): TaskFeedbackService{
    return new TaskFeedbackService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TaskFeedbackService',
      plural: 'TaskFeedbackServices',
      path: 'TaskFeedbackServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/TaskFeedbackService.ts